import { useQuery } from "@apollo/react-hooks";
import { MY_CAFETERIA_MY_TIME_GET_PERIODS } from "my-cafeteria/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyCafeteriaPeriods = () => {
  const { data, loading, error } = useQuery(MY_CAFETERIA_MY_TIME_GET_PERIODS, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
  });

  const result = data?.getCafeteriaPeriods;

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyCafeteriaPeriods;
